import { Input } from 'antd';
import React, { useEffect } from 'react';
import styled, { css } from 'styled-components';

import { maybeAddChangeListener } from 'stores/DynamicProperties/changeListeners';
import { type IDynamicProperty } from 'stores/DynamicProperties/IDynamicProperty';
import { useForceUpdate } from 'utils/Hooks';

const { TextArea } = Input;

const Container = styled.div<{ $changed: boolean }>`
    display: flex;
    align-items: center;
    margin-bottom: 7px;
    width: 540px;

    ${(p) =>
        p.$changed &&
        css`
            textarea {
                background: #e1f3ff;
            }
        `}
`;

const PropertyInput = styled(TextArea)`
    flex-grow: 1;
    width: 100%;
`;

type MultiLineTextInputProps = {
    disabled?: boolean;
    property: IDynamicProperty<any>;
};

// Not an observer, deliberately. Nothing read during render is observable: a
// leaf DynamicProperty never calls becomeObservable, and the only path that
// would make one observable - DynamicGroup.enableState - has no callers.
// Re-rendering comes entirely from the subscription below.
function MultiLineTextInput({ disabled, property }: MultiLineTextInputProps) {
    const forceUpdate = useForceUpdate();
    useEffect(
        () => maybeAddChangeListener(property, forceUpdate),
        [property, forceUpdate]
    );

    const handleInputChange = (
        event: React.ChangeEvent<HTMLTextAreaElement>
    ) => {
        property.set(event.target.value);
    };

    return (
        <Container $changed={property.getChanged()}>
            <PropertyInput
                disabled={disabled}
                placeholder="Enter custom value"
                onChange={handleInputChange}
                value={property.value}
                autoSize={{ minRows: 1, maxRows: 5 }}
            />
        </Container>
    );
}

export default MultiLineTextInput;
